// extracted by mini-css-extract-plugin
export var container = "Container-module--container--Z2HCW";
export var large = "Container-module--large--0tvrz";
export var medium = "Container-module--medium--cie-U";
export var min = "Container-module--min--0V56m";
export var none = "Container-module--none--b9lDV";
export var fullMobile = "Container-module--fullMobile--W+BBb";